import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"label":"Guru","value":_vm.value,"placeholder":"Pilih Guru","items":_vm.guru},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }